import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { TrimItemStyled } from '../../TrimItemStyled';
import media from '../../../../styles/media';
import { rem } from 'polished';

export const TrimItemStyledACGB = styled(TrimItemStyled)`
    .buttonWrapper a {
        width: 100%;
    }

    .trimContainer {
        .buttonWrapper a {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        .equipmentList {
            @media (min-width: ${breakpoints.sm}px) {
                margin-top: ${rem('35px')};
            }

            &__info {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
                padding-left: ${rem('10px')};
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                color: ${({ theme }) => theme.colors.black2};
            }

            &__list {
                list-style-type: none;
                padding-left: ${rem('10px')};
            }

            &__list--item {
                font-family: ${({ theme }) => theme.fonts.fontBase};
                display: flex;
                align-items: center;
                &:not(:last-of-type) {
                    margin-bottom: 10px;
                }
                &:first-of-type {
                    margin-top: ${rem('5px')};
                }
            }

            &__list--item::before {
                content: '';
                width: 6px;
                min-width: 6px;
                display: inline-block;
                height: 6px;
                border-radius: 50%;
                background: ${({ theme }) => theme.colors.red};
                margin-right: 8px;
                align-self: flex-start;
                margin-top: ${rem(8)};
            }
        }

        .priceInfo {
            text-align: center;
            margin-top: ${rem('13px')};
            .priceInfo__text {
                color: ${({ theme }) => theme.colors.grey13};
                font-size: ${rem('14px')};
            }
        }

        .header {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            .title {
                color: ${({ theme }) => theme.colors.grey5} !important;
                font-size: 28px;
                font-weight: normal;

                &--detail {
                    font-weight: bold !important;
                }
            }
        }

        .equipmentSubtitle {
            p {
                font-weight: normal;
                font-size: ${rem('12px')} !important;
                color: ${({ theme }) => theme.colors.black} !important;
                text-transform: none !important;
                margin: ${rem('5px')} 0 ${rem('10px')} 0;
            }
        }

        .benefits {
            & > .heading {
                font-family: ${({ theme }) => theme.fonts.fontSecondary} !important;
                margin-bottom: ${rem('6px')};
                padding-left: ${rem('10px')};
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                color: ${({ theme }) => theme.colors.black2};
            }
            ul {
                list-style-type: none;
                li {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    font-family: ${({ theme }) => theme.fonts.fontBase} !important;

                    &::before {
                        content: '';
                        width: 6px;
                        min-width: 6px;
                        display: inline-block;
                        height: 6px;
                        border-radius: 50%;
                        background: ${({ theme }) => theme.colors.red};
                    }
                }
            }
            .offer {
                & > div:first-of-type {
                    margin-right: ${rem('12px')};
                }
            }
        }
        .options {
            font-family: ${({ theme }) => theme.fonts.fontBase};
            padding-left: ${rem('8px')};

            .colorOption {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .colorButtonWrapper {
                    button {
                        border-color: transparent !important;
                        border-radius: 50%;
                        padding: 0;
                        background-size: cover;
                    }
                }
            }

            .engineOption {
                height: ${rem('30px')};
                width: ${rem('30px')};

                .engineText {
                    flex-wrap: nowrap;
                    > span {
                        min-width: ${rem('100px')};
                    }
                }
            }
        }

        .tooltip > div:last-child {
            left: 58% !important;
            right: -60% !important;

            &::after {
                left: 20px;
                border-bottom: none !important;
                top: -3px;
            }
            ${media.md`
                left: 58% !important;
            `}
        }

        .priceWrap {
            @media (min-width: ${breakpoints.lg}px) {
                &--price.OTR,
                .currencyLabel__suffix--OTR {
                    font-size: ${({ theme }) => theme.fontSizes.h4};
                }

                &--price {
                    font-size: ${rem(21)};
                }

                &--bonusLabel {
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                }
                &--bonusLink  {
                    font-size: ${({ theme }) => theme.fontSizes.h6};
                }
            }
        }
        
        .descriptionWrapper {
            &-payment-link {
                color: ${({ theme }) => theme.colors.red};
            }
        }
    }
`;
